import React, { useMemo } from 'react';
import { Table } from '../Table';
import { Skeleton } from './Skeleton';
export function SkeletonTable(props) {
    const { rows = 5, columns = 3, ...rest } = props;
    return (React.createElement(Table, { ...rest },
        React.createElement(Table.Head, null,
            React.createElement(Table.Row, null, useMemo(() => Array.from({ length: columns }).map((_, index) => (React.createElement(Table.Header, { key: index },
                React.createElement(Skeleton, null)))), [columns]))),
        React.createElement(Table.Body, null, useMemo(() => Array.from({ length: rows }).map((_, rowIndex) => (React.createElement(Table.Row, { key: rowIndex }, Array.from({ length: columns }).map((_, index) => (React.createElement(Table.Cell, { key: index },
            React.createElement(Skeleton, { faded: (() => {
                    switch (true) {
                        case rowIndex === rows:
                            return 'heavy';
                        case rowIndex === rows - 1:
                            return true;
                        case rowIndex === rows - 2:
                            return 'light';
                    }
                    return;
                })() }))))))), [columns, rows]))));
}
SkeletonTable.displayName = 'Skeleton.Table';
//# sourceMappingURL=SkeletonTable.js.map